module.exports = __webpack_public_path__ + "img/signout.144ff030.svg";